import { getConditionNodeIds } from '../../condition-engine/getConditionNodeIds';
import { getInitialFieldValue } from '../questionnaire';
import { TransitionVisitor } from '../TransitionVisitor';
class TransformVisitor extends TransitionVisitor {
    fieldTransform;
    sectionTransform;
    subsectionTransform;
    fieldGroupTransform;
    constructor(callbacks) {
        super();
        this.fieldTransform = callbacks.fieldTransform;
        this.sectionTransform = callbacks.sectionTransform;
        this.subsectionTransform = callbacks.subsectionTransform;
        this.fieldGroupTransform = callbacks.fieldGroupTransform;
    }
    visitField(field) {
        if (this.fieldTransform) {
            this.fieldTransform(field, this.stopVisit);
        }
    }
    visitSection(section) {
        if (this.sectionTransform) {
            this.sectionTransform(section, this.stopVisit);
        }
        else {
            super.visitSection(section);
        }
    }
    visitSubsection(subsection) {
        if (this.subsectionTransform) {
            this.subsectionTransform(subsection, this.stopVisit);
        }
        else {
            super.visitSubsection(subsection);
        }
    }
    visitFieldGroup(fieldGroup) {
        if (this.fieldGroupTransform) {
            this.fieldGroupTransform(fieldGroup, this.stopVisit);
        }
        else {
            super.visitFieldGroup(fieldGroup);
        }
    }
}
export function transformFields(questionnaire, callback) {
    const visitor = new TransformVisitor({ fieldTransform: callback });
    visitor.visitQuestionnaire(questionnaire);
}
export function transformFieldsInSection(section, callback) {
    const visitor = new TransformVisitor({ fieldTransform: callback });
    visitor.visitSection(section);
}
export function transformSections(questionnaire, callback) {
    const visitor = new TransformVisitor({ sectionTransform: callback });
    visitor.visitQuestionnaire(questionnaire);
}
export function transformSubsections(questionnaire, callback) {
    const visitor = new TransformVisitor({ subsectionTransform: callback });
    visitor.visitQuestionnaire(questionnaire);
}
export function transformFieldGroups(questionnaire, callback) {
    const visitor = new TransformVisitor({ fieldGroupTransform: callback });
    visitor.visitQuestionnaire(questionnaire);
}
export function setFieldValues(questionnaire, answersResolver) {
    transformFields(questionnaire, (field) => {
        const answer = answersResolver
            .usingNodeId()
            .getAnswer(field.blueprintId, field.metadata.repeatedInstanceIdentifierContext.byBlueprintId);
        const fieldWithValue = field;
        fieldWithValue.value = typeof answer === 'undefined' ? getInitialFieldValue(field) : answer;
        if (field.defaultIf !== undefined) {
            field.appendToKeyValue = getAppendToKeyValueForFieldWithDefaultIf(field, answersResolver);
        }
        if (field.relatesTo !== undefined) {
            const relatesToValue = answersResolver.usingNodeId().getAnswer(field.relatesTo, // TODO: relatesTo uses node ids
            field.metadata.repeatedInstanceIdentifierContext.byNodeId);
            if (typeof relatesToValue !== 'undefined') {
                const appendToKeyValue = fieldWithValue.appendToKeyValue ?? '';
                fieldWithValue.appendToKeyValue = getAppendToKeyValue(appendToKeyValue, relatesToValue);
            }
        }
    });
}
export function getAppendToKeyValueForFieldWithDefaultIf(field, answersResolver) {
    let appendToKeyValue = '';
    const defaultIf = field.defaultIf ?? [];
    for (const rule of defaultIf) {
        if (rule.conditions) {
            const nodeIds = getConditionNodeIds(rule.conditions);
            for (const nodeId of nodeIds) {
                const relatesToValueAnswer = answersResolver.usingNodeId().getAnswer(nodeId, field.metadata?.repeatedInstanceIdentifierContext.byNodeId);
                if (typeof relatesToValueAnswer !== 'undefined') {
                    appendToKeyValue = getAppendToKeyValue(appendToKeyValue, relatesToValueAnswer);
                }
            }
        }
    }
    return appendToKeyValue || 'defaultValueCondition';
}
export function getAppendToKeyValue(appendToKeyValue = '', relatesToValue) {
    const delimiter = appendToKeyValue.length > 0 ? '.' : '';
    return `${appendToKeyValue}${delimiter}${relatesToValue}`;
}
